export const environment = {
  production: true,
  api_url: 'https://portal-api.aumentcoin.com/v1',
  api_key: 'YXVtZW50LWFkbWluOmF1bWVudC1hZG1pbi1zZWNyZXQ='
};
